// extracted by mini-css-extract-plugin
export default {"wrapper":"PageScroll_wrapper--QDk","nextButton":"PageScroll_nextButton--S_f","overflow":"PageScroll_overflow--RcH"};